import { render, staticRenderFns } from "./stars-input.vue?vue&type=template&id=ca325c62&"
import script from "./stars-input.vue?vue&type=script&lang=js&"
export * from "./stars-input.vue?vue&type=script&lang=js&"
import style0 from "./stars-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca325c62')) {
      api.createRecord('ca325c62', component.options)
    } else {
      api.reload('ca325c62', component.options)
    }
    module.hot.accept("./stars-input.vue?vue&type=template&id=ca325c62&", function () {
      api.rerender('ca325c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/stars-input.vue"
export default component.exports